import { render, staticRenderFns } from "./form-edit-general.vue?vue&type=template&id=5a395343&"
import script from "./form-edit-general.vue?vue&type=script&lang=ts&"
export * from "./form-edit-general.vue?vue&type=script&lang=ts&"
import style0 from "./form-edit-general.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports